import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import MenuView from "../views/MenuView.vue";
import AccountView from "../views/AccountView.vue";
import DemandesView from "../views/DemandesView.vue";
import DemandeView from "../views/DemandeView.vue";
import FichesDmView from "../views/FichesDmView.vue";
import ApercuProduitView from "../views/ApercuProduitView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    beforeEnter: (to, from, next) => {
      store.dispatch("logout");
      next();
    },
  },
  // route temporaire pour tests
  {
    path: "/frns-22-test",
    name: "tempTestHome",
    redirect: { name: "home" },
  },
  {
    path: "/menu",
    name: "menu",
    component: MenuView,
    meta: { protected: true },
  },
  {
    path: "/me",
    name: "me",
    component: AccountView,
    meta: { protected: true },
  },
  {
    path: "/demandes/:id?",
    name: "demande",
    component: DemandeView,
    props: true,
    meta: { protected: true },
  },
  {
    path: "/demandes",
    name: "demandes",
    component: DemandesView,
    meta: { protected: true },
  },

  {
    path: "/fiches-dm",
    name: "dispositifs",
    component: FichesDmView,
    meta: { protected: true },
  },
  {
    path: "/apercu",
    name: "apercu",
    component: ApercuProduitView,
    meta: { protected: true },
  },
  {
    path: "*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log("Start going to", to.name);
  store.dispatch("startLoading");

  if (to.meta.protected) {
    if (store.state.identite.token != "") {
      next();
    } else {
      next({ name: "home" });
    }
  } else {
    next();
  }
});

router.onError((err) => {
  //console.log("In global router error handler");
  if (err.originalError) {
    store.dispatch("setErreur", err.originalError);
  }

  store.dispatch("stopLoading");
});

router.afterEach(() => {
  store.dispatch("stopLoading");
});

export default router;
